import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/BannerSortModal.css"; // 스타일을 외부 CSS 파일로 관리

const BannerSortModal = ({ onClose, onSave }) => {
  const [sortedBanners, setSortedBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get("/bannersortlist");

        // sortIdx 내림차순으로 정렬
        const sortedData = response.data.sort(
          (a, b) => b.sort_idx - a.sort_idx
        );

        setSortedBanners(sortedData);
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };

    fetchBanners();
  }, []);

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("draggedIndex", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex) => {
    const draggedIndex = parseInt(e.dataTransfer.getData("draggedIndex"), 10);

    const updatedBanners = [...sortedBanners];
    const [draggedItem] = updatedBanners.splice(draggedIndex, 1);
    updatedBanners.splice(dropIndex, 0, draggedItem);

    const bannersWithUpdatedSort = updatedBanners.map((banner, index) => ({
      ...banner,
      sort: index + 1, // 새로운 sort 값 설정
    }));

    setSortedBanners(bannersWithUpdatedSort);
  };

  const handleSave = async () => {
    try {
      const formattedData = sortedBanners.map((banner, index) => ({
        bnIdx: banner.bnIdx,
        sort: index + 1,
      }));

      const response = await axios.post("/updateBannerSort", formattedData, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("Server Response:", response.data);

      alert("배너 정렬이 성공적으로 저장되었습니다");

      onClose(); // 모달 닫기
    } catch (error) {
      console.error("Error saving sorted banners:", error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h3 className="modal-title">배너 정렬</h3>
        <ul className="modal-list">
          {sortedBanners.map((banner, index) => (
            <li
              key={banner.bnIdx}
              draggable
              onDragStart={(e) => handleDragStart(e, index)}
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, index)}
              className="modal-item"
            >
              {banner.rTitle}
            </li>
          ))}
        </ul>
        <div className="modal-buttons">
          <button className="modal-button-save" onClick={handleSave}>
            저장
          </button>
          <button className="modal-button-close" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default BannerSortModal;
